const defaults = {
    fitmentHeading: 'No Configuration Required',
    fitmentDescription: 'Based on your vehicle selection, your interior configuration is already set. You can safely proceed to the next step.',
    materialHeading: 'No Material Options Required',
    materialDescription: 'Your selected vehicle and fitment use a standard factory layout. No additional material setup is needed for this model.',
    configurationHeading: 'No Extra Options Required',
    configurationDescription: 'This vehicle uses a standard factory layout. Fitment and material options are pre-selected for your model, so no additional setup is needed.',
    skippedFitmentHeading: 'Fitment skipped automatically',
    skippedFitmentDescription: 'Your selected vehicle model uses a standard layout, so no additional configuration is required.',
    skippedFitmentTooltip: "Your vehicle layout doesn't require extra configuration.",
    singleOptionMessage: 'The results shown are only available for {value}',
    foamOnlyHeading: "Seat Covers Aren't Available for Your [Year] [Make] [Model]",
    foamOnlyDescription: "We don't currently offer replacement seat covers for this vehicle, but you can still get a proper fit with the replacement seat foam below.",
    foamOnlyLinkLabel: 'Request Seat Covers for This Vehicle',
    foamOnlyLinkUrl: '/pages/cant-find-your-vehicle'
};

export const getFilterAppMessage = key => {
    const configured = window.sf_options?.filterAppMessages?.[key];
    return typeof configured === 'string' && configured.trim()
        ? configured.trim()
        : defaults[key];
};

const escapeHtml = value => String(value ?? '').replace(/[&<>"']/g, char => ({
    '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'
}[char]));

// Single-option alerts use HTML to emphasize the option; all editable copy stays plain text.
export const getSingleOptionMessage = value => escapeHtml(getFilterAppMessage('singleOptionMessage'))
    .split('{value}').join(`<strong>${escapeHtml(value)}</strong>`);
